import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import BookMeeting from './pages/BookMeeting';
import MyMeetings from './pages/MyMeetings';
import SuperAdminDashboard from './pages/admin/SuperAdminDashboard';
import CompanyAdminDashboard from './pages/admin/CompanyAdminDashboard';
import RequestMeetingFromBuyer from './pages/RequestMeetingFromBuyer';
import BuyerAdminDashboard from './pages/admin/BuyerAdminDashboard';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/book-meeting/:companyId"
                element={
                  <ProtectedRoute>
                    <BookMeeting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-meetings"
                element={
                  <ProtectedRoute>
                    <MyMeetings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/super-admin"
                element={
                  <ProtectedRoute superAdminOnly={true}>
                    <SuperAdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/company-admin"
                element={
                  <ProtectedRoute adminOnly={true}>
                    <CompanyAdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/request-meeting-from-buyer/:buyerId"
                element={
                  <ProtectedRoute adminOnly={true}>
                    <RequestMeetingFromBuyer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/buyer/dashboard"
                element={
                  <ProtectedRoute>
                    <BuyerAdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
